module.exports = __webpack_public_path__ + "img/08.42f0b352.jpg";